import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../../../../../common/widgets/Button';
import Dialog from '../../../../../../../common/widgets/Dialog';
import Dropdown from '../../../../../../../common/widgets/Dropdown';
import Multiselect from '../../../../../../../common/widgets/Multiselect';
import {
  CityFilterModel,
  CountyFilterModel,
} from '../../../../../models/filters';
import { resources } from '../../../../../resources/resources';

interface AddLocationDialogProps {
  countiesWithCities: CountyFilterModel[];
  selectedCountiesWithCities: CountyFilterModel[];
  closeDialog: () => void;
  addLocation: (selectedCountyWithCities: CountyFilterModel) => void;
}

export const AddLocationDialog = (props: AddLocationDialogProps) => {
  const {
    countiesWithCities,
    selectedCountiesWithCities,
    closeDialog,
    addLocation,
  } = props;
  const [selectedCounty, setSelectedCounty] = useState<
    CountyFilterModel | undefined
  >();
  const [selectedCities, setSelectedCities] = useState<
    CityFilterModel[] | undefined
  >();
  const { t: translate } = useTranslation();
  const allCitiesFilterId = -1;

  const cities = selectedCounty?.cities?.length
    ? [
        {
          name:
            selectedCounty.cities.length === 1
              ? translate(
                  resources.products.add.productDetails.location.addLocations
                    .dialog.allCities.single,
                )
              : translate(
                  resources.products.add.productDetails.location.addLocations
                    .dialog.allCities.multiple,
                  { 0: selectedCounty.cities.length },
                ),
          filterId: allCitiesFilterId,
        },
        ...selectedCounty.cities,
      ]
    : [];

  return (
    <Dialog
      closeDialog={closeDialog}
      showCloseIcon
      className="dialog-merchants-edit"
    >
      <div className="dialog-content">
        <div className="dialog-title">
          {translate(
            resources.products.add.productDetails.location.addLocations.dialog
              .title,
          )}
        </div>
        <div className="dialog-text centered mb-20">
          {translate(
            resources.products.add.productDetails.location.addLocations.info,
          )}
        </div>
        <Dropdown
          data={countiesWithCities.filter(
            e =>
              !selectedCountiesWithCities.some(s => s.filterId === e.filterId),
          )}
          value={selectedCounty ?? { name: translate(resources.select) }}
          onChange={e => {
            setSelectedCounty(e.value);
            setSelectedCities([]);
          }}
          textField="name"
          dataItemKey="filterId"
          label={translate(
            resources.products.add.productDetails.location.addLocations.dialog
              .county,
          )}
        />
        <Multiselect
          controlClassName="mb-0"
          data={cities}
          value={selectedCities}
          placeholder={translate(resources.select)}
          onChange={e => {
            if (
              e.value.some(
                (f: CityFilterModel) => f.filterId === allCitiesFilterId,
              )
            ) {
              setSelectedCities(selectedCounty?.cities ?? []);
            } else {
              setSelectedCities(e.value);
            }
          }}
          textField="name"
          dataItemKey="filterId"
          label={translate(
            resources.products.add.productDetails.location.addLocations.dialog
              .city,
          )}
          disabled={!selectedCounty}
        />
      </div>

      <div className="dialog-actions vertical">
        <Button
          className="btn btn-solid"
          onClick={() =>
            addLocation({
              filterId: selectedCounty!.filterId,
              name: selectedCounty!.name,
              cities: selectedCities!,
            })
          }
          disabled={!selectedCities?.length}
        >
          <span className="btn-text">
            {translate(
              resources.products.add.productDetails.location.addLocations
                .button,
            )}
          </span>
        </Button>
      </div>
    </Dialog>
  );
};
